import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import {
      Admin_Parivartan_Create_New_City,
    Admin_Parivartan_Get_All_States,
  } from "../../../../constants";
  import axios from "axios";
  import toast from "react-hot-toast";
  
  const AddCityModal = ({ open, onClose, onRefresh }) => {
    const [form, setForm] = useState({
      StateName: "",
      CityName: ""
    });
    const [stateList, setStateList] = useState([]);
    const [regionList, setRegionList] = useState([]);
  
    const fetchStateData = async () => {
      try {
        const response = await axios.get(`${Admin_Parivartan_Get_All_States}`);
        setStateList(response.data.data || []);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      }
    };
  
    // const fetchRegion = async () => {
    //   try {
    //     const response = await axios.get(`${Admin_Region_Name}`);
    //     setRegionList(response.data.data || []);
    //   } catch (error) {
    //     console.error("Error fetching attendance data:", error);
    //   }
    // };
  
    useEffect(() => {
        fetchStateData();
    //   fetchRegion();
    }, [open]);
  
    const handleChange = (field, value) => {
      setForm((prev) => ({ ...prev, [field]: value }));
    };
  
    const handleSubmit = async () => {
      const payload = {
        CityName: form.CityName,
        StateName: form.StateName,
      };
  
      try {
        const res = await axios.post(Admin_Parivartan_Create_New_City, payload);
        if (res.data.success) {
          toast.success("City Created Successfully.");
          onRefresh();
          onClose();
          handleReset();
        } else {
          toast.error(res.data.message || "Failed to create city");
        }
      } catch (err) {
        const message =
          err?.response?.data?.message || err?.message || "Something went wrong";
        toast.error(message);
      }
    };
  
    const handleReset = () => {
      setForm({
        StateName: "",
        CityName: "",
      });
    };
  
    return (
      <>
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Add New City
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} mt={1}>  
              <FormControl fullWidth>
                <InputLabel id="branch-label">State Name</InputLabel>
                <Select
                  labelId="branch-label"
                  label="State Name"
                  value={form.StateName}
                  onChange={(e) => handleChange("StateName", e.target.value)}
                  size="small"
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {stateList.map((st) => (
                    <MenuItem key={st.StateCode} value={st.StateName}>
                      {st.StateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
  
              <FormControl fullWidth>
                <TextField
                  label="City Name"
                  value={form.CityName}
                  onChange={(e) => handleChange("CityName", e.target.value)}
                  variant="outlined"
                  size="small"
                />
              </FormControl>
  
              
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };
  
  export default AddCityModal;
  